// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessagingChatClientes_LinkInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/messaging_chat_clientes/link
 *
 * Create a chat-client link.
 * Supports both old format { phone: "..." } and new format { identifier: "...", identifier_type: "..." }.
 */
import { registerContract } from './validate'

export interface MessagingChatClientes_LinkInput {
cliente_id: number
identifier?: string
identifier_type?: string
phone?: string
link_type?: string
device_id?: number
whatsappfranquia_id?: number
}

registerContract('MessagingChatClientes_LinkInput', {
  cliente_id:          { type: 'number',  required: true },
  identifier:          { type: 'string',  required: false },
  identifier_type:     { type: 'string',  required: false },
  phone:               { type: 'string',  required: false },
  link_type:           { type: 'string',  required: false },
  device_id:           { type: 'number',  required: false },
  whatsappfranquia_id: { type: 'number',  required: false },
})
